- id: people--people-01
  name: Nora
  width: 0.5
- id: people--people-02
  width: 0.5
- id: people--people-03
  width: 0.5
- id: people--people-04
  width: 0.5
- id: people--people-05
  width: 0.5
- id: people--people-06
  width: 0.5
- id: people--people-07
  width: 0.5
- id: people--people-08
  width: 0.5
- id: people--people-09
  width: 0.5
- id: people--people-10
  width: 0.5
- id: people--people-11
  width: 0.5
- id: people--people-12
  width: 0.5
- id: people--people-13
  width: 0.5
- id: people--people-14
  width: 0.75
- id: people--people-15
  name: Lou
  width: 0.5
- id: people--people-16
  width: 0.75
- id: people--people-17
  width: 0.75
- id: people--people-18
  width: 0.75
- id: people--people-19
  width: 0.75
  disallowFirst: true
- id: people--people-20
  width: 0.75
  disallowFirst: true
- id: people--people-21
  width: 0.25
- id: people--people-22
  width: 0.25
- id: people--people-23
  name: Katie
  width: 0.75
- id: people--people-24
  width: 1.25
- id: people--people-25
  width: 0.5
- id: people--people-26
  width: 0.75
- id: people--people-27
  width: 0.5
- id: people--people-28
  width: 1
- id: people--people-29
  width: 1.25
- id: people--people-30
  width: 0.75
- id: people--people-31
  width: 0.5
- id: people--johnny-01
  name: Johnny
  alts:
    - people--johnny-02
  width: 0.75
  disallowFirst: true
  weight: 5
- id: people--junebug-01
  name: Junebug
  alts:
    - people--junebug-02
    - people--junebug-03
  width: 0.75
  disallowFirst: true
  weight: 5
- id: people--bernie
  width: 0.75
  name: Bernie
  weight: 1
- id: people--people-32
  width: 0.5
  alts:
    - people--people-32-back
  tags:
    - beach
  weight: 500
- id: people--people-33
  width: 0.5
  alts:
    - people--people-33-back
  tags:
    - beach
  weight: 500
- id: people--people-34
  width: 0.5
  alts:
    - people--people-34-back
  tags:
    - beach
  weight: 500
- id: people--people-35
  width: 0.5
  alts:
    - people--people-35-back
  weight: 500
- id: people--people-36
  width: 0.5
  alts:
    - people--people-36-back
  tags:
    - beach
  weight: 500
- id: people--people-37
  width: 0.5
  alts:
    - people--people-37-back
  tags:
    - beach
  weight: 500
- id: people--people-38
  width: 0.5
  alts:
    - people--people-38-back
  tags:
    - beach
  weight: 500
- id: people--people-39
  width: 1.25
  tags:
    - beach
  # Temporarily make this rarer because it's very wide and can get cut off
  # at the right edge. No good fix for now, but at least we wouldn't see it
  # occur as frequently
  weight: 100
